import React, { useState } from 'react'
import $t from '../../../../i18n'
import copayRatesIcon from 'resources/copayRatesIcon.png'
import Card from 'components/common/Card'
import { planRates ,planTemplateTypes} from 'consts/PlanDetailsConsts'
import { Dropdown, Space } from 'antd'

import { DownOutlined } from '@ant-design/icons'

import './CopayCard.css'

const items = [
  {
    label: $t(`pages.coverageBenefits.planRates.${planRates.VIRTUAL}`),
    key: planRates.VIRTUAL,
  },
  {
    label: $t(`pages.coverageBenefits.planRates.${planRates.REFERRAL}`),
    key: planRates.REFERRAL,
  },
  {
    label: $t(`pages.coverageBenefits.planRates.${planRates.TIER1}`),
    key: planRates.TIER1,
  },
  {
    label: $t(`pages.coverageBenefits.planRates.${planRates.TIER2}`),
    key: planRates.TIER2,
  },
  {
    label: $t(`pages.coverageBenefits.planRates.${planRates.NETWORK}`),
    key: planRates.NETWORK,
  }
  
]

const filterCopayMenu = (templateType) => {
  if ([planTemplateTypes.OH_CATASTROPHIC, planTemplateTypes.AZ_CATASTROPHIC].includes(templateType)) {
    return null
  }
  if ([planTemplateTypes.AZ_COMPLETE_ELITE, planTemplateTypes.OH_COMPLETE_ELITE, planTemplateTypes.AZ_SMALL_GROUPS].includes(templateType)) {
    return items.filter(item => (item.key === planRates.VIRTUAL || item.key === planRates.REFERRAL ||
       item.key === planRates.TIER1 || item.key === planRates.TIER2))
  }
  if ([planTemplateTypes.OH_STANDARD, planTemplateTypes.AZ_STANDARD].includes(templateType)) {
    return items.filter(item => (item.key === planRates.VIRTUAL || item.key === planRates.NETWORK))
  }
  else {
    return null
  }
}

const CopayCard = ({ subscription }) => {
  const planMetadataRates = subscription?.plan_details
  const templateType = subscription?.plan_details.template_type
  const [selectedRate, setSelectedRate] = useState(planRates.VIRTUAL)

  const isCatastrophicTemplateType = templateType?.includes('catastrophic')
  const copayDropdownItems = filterCopayMenu(templateType)

  const onRateClick = ({ key }) => {
    setSelectedRate(key)
  }

  const allPlanRates = () => {
    return (
      <div className="rates">
        <div className="rate-row">
          <span>{$t('pages.coverageBenefits.planRates.pcp')}:</span>
          <span>{planMetadataRates?.pcp_rates[selectedRate] || '-'}</span>
        </div>
        <div className="rate-row">
          <span>{$t('pages.coverageBenefits.planRates.specialist')}:</span>
          <span>
            {planMetadataRates?.specialist_rates[selectedRate] || '-'}{' '}
          </span>
        </div>
        <div className="rate-row">
          <span>{$t('pages.coverageBenefits.planRates.mentalHealth')}:</span>
          <span>
            {planMetadataRates?.mental_health_rates[selectedRate] || '-'}
          </span>
        </div>
      </div>
    )
  }

  const catastrophicPlanRates = () => {
    return (
      <div className="rates">
        <div className="rate-row cts">
          <span>{$t('pages.coverageBenefits.planRates.pcp')}:</span>
          <span className="cts-rate">
            {$t('pages.coverageBenefits.planRates.catastrophicRates.pcp')}
          </span>
        </div>
        <div className="rate-row cts">
          <span>{$t('pages.coverageBenefits.planRates.specialist')}:</span>
          <span className="cts-rate">
            {$t(
              'pages.coverageBenefits.planRates.catastrophicRates.specialist'
            )}
          </span>
        </div>
        <div className="rate-row cts">
          <span>{$t('pages.coverageBenefits.planRates.mentalHealth')}:</span>
          <span className="cts-rate">
            {$t(
              'pages.coverageBenefits.planRates.catastrophicRates.mentalHealth'
            )}
          </span>
        </div>
      </div>
    )
  }

  return (
    <Card className="copay-card">
      <div className="copay-card-title">
        <img
          src={copayRatesIcon}
          alt="coverage-benefits"
          className="copay-image"
        />
        <h2 className="coverage-copay-card-title semi-bold">
          {$t('pages.coverageBenefits.copays')}
        </h2>
      </div>
      <div className="details-in-card">
        { copayDropdownItems &&
          <Dropdown 
            menu={{items: copayDropdownItems , onClick: onRateClick }}
            className="copay-rates-dropdown"
          >
            <a onClick={e => e.preventDefault()}>
              <Space>
                {$t('pages.coverageBenefits.planRates.visitCopay')}{' '}
                <span className="copay-rate-dropdown-label">
                  {$t(`pages.coverageBenefits.planRates.${selectedRate}`)}
                </span>
                <DownOutlined />
              </Space>
            </a>
          </Dropdown>
        } 
        {isCatastrophicTemplateType ? catastrophicPlanRates() : allPlanRates()}
      </div>
    </Card>
  )
}

export default CopayCard
